import { ISection } from '@creditflowresearch/uilib/Section';
import { isItemActive } from '@/creditflowresearch/ui/common/utils/url/activeItemMatcher';
import { applyActiveState } from './applyActiveState';

export const applyActiveStateToSections = (
  sections: ISection[][][],
  currentPath: string,
): ISection[][][] => {
  return sections.map((row) =>
    row.map((column) =>
      column.map((section) => ({
        ...section,
        isActive: section.sectionHref
          ? isItemActive(section.sectionHref, currentPath)
          : false,
        items: applyActiveState(section.items, currentPath),
      })),
    ),
  );
};
